<script setup>
import { useWebsiteSettings } from "@/composables/settings";
import { computed } from "vue";

const ws = useWebsiteSettings();
const DEFAULT_APP_NAMES = ["Dodock", "Dokos", "Frappe", "ERPNext"];
const isDefaultAppName = computed(() =>
  DEFAULT_APP_NAMES.includes(ws.value?.app_name),
);
</script>

<template>
  <div class="flex gap-2 items-center BLayoutBrand">
    <template v-if="ws?.brand_html">
      <span class="truncate" v-html="ws?.brand_html"></span>
    </template>
    <template v-else-if="ws?.banner_image">
      <img class="size-7 rounded-sm" :src="ws?.banner_image" />
    </template>

    <template v-else-if="isDefaultAppName">
      <span class="truncate">Portail</span>
    </template>
    <template v-else>
      <span class="truncate text-title-2 font-semibold opacity-90">
        {{ ws?.app_name }}
      </span>
    </template>
  </div>
</template>

<style>
.BLayoutBrand img {
  max-width: 150px !important;
  max-height: 32px !important;
}
</style>
